import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: 'app-loader-component',
    template: `<app-loader [textDisplay]="loadingText" [isHalfSize]="isHalfSize" [color]="color"></app-loader>`,
    styles: [`
        :host {
            width: 100%;
            height: 100%;
            z-index: 1054;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0, 0, 0, .6);
        }
    `]
})
export class LoaderComponent {
    @Input() loadingText: string | null = null;
    @Input() isHalfSize: boolean = false;
    @Input() color: string = '#FFF';
}